function setupDropdowns() {
  if (typeof eventBus === 'undefined') {
    setTimeout(setupDropdowns, 100);
    return;
  }

  const userClicked = new Set();

  function getUnselected() {
    if (document.querySelector('out-of-stock-form')) return [];
    const unselected = [];
    document.querySelectorAll('variant-dropdown[data-placeholder]').forEach(function(dd) {
      const idx = dd.getAttribute('data-option-index');
      if (!userClicked.has(idx)) {
        unselected.push({
          idx: idx,
          placeholder: dd.getAttribute('data-placeholder')
        });
      }
    });
    return unselected;
  }

  function updateCartButton() {
    if (document.querySelector('out-of-stock-form')) {
      document.querySelectorAll('.options-error-message').forEach(function(msg) {
        msg.remove();
      });
      return;
    }
    document.querySelectorAll('[data-validate-options]').forEach(function(btn) {
      const form = btn.closest('product-form');
      if (!form) return;
      const unselected = getUnselected();
      let msg = form.querySelector('.options-error-message');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'options-error-message';
        const wrapper = btn.closest('.paymentButtonsWrapper');
        if (wrapper) {
          wrapper.parentNode.insertBefore(msg, wrapper);
        } else {
          btn.parentNode.insertBefore(msg, btn);
        }
      }
      if (unselected.length > 0) {
        btn.setAttribute('disabled', 'disabled');
        msg.textContent = 'Please ' + unselected.map(function(u) {
          return u.placeholder.toLowerCase();
        }).join(' and ') + ' before adding to cart.';
      } else {
        btn.removeAttribute('disabled');
        msg.textContent = '';
      }
    });
  }

  function checkUnavailableSizes() {
    const selectedSize = document.querySelector('variant-dropdown[data-option-index="0"] [data-selected-option]');
    if (!selectedSize) return;
    const sizeValue = selectedSize.textContent.trim();
    if (sizeValue === '7' || sizeValue === '7.5') {
      document.querySelectorAll('variant-dropdown[data-option-index="1"] .dropdown-list--item').forEach(function(item) {
        if (item.getAttribute('data-option-value') === 'EE (wide)') {
          const statusText = item.querySelector('[data-status-text]');
          if (statusText) {
            statusText.textContent = '(Not Available)';
          }
        }
      });
    }
  }

  document.addEventListener('click', function(e) {
    const option = e.target.closest('[data-product-variant]');
    if (option) {
      const dd = option.closest('variant-dropdown[data-placeholder]');
      if (dd) {
        const idx = dd.getAttribute('data-option-index');
        userClicked.add(idx);
        setTimeout(updateCartButton, 50);
      }
    }
  }, true);

  eventBus.on('variant:updated', function() {
    document.querySelectorAll('variant-dropdown[data-placeholder]').forEach(function(dd) {
      const display = dd.querySelector('[data-selected-option]');
      const selected = dd.querySelector('[data-product-variant].selected');
      const placeholder = dd.getAttribute('data-placeholder');
      const idx = dd.getAttribute('data-option-index');
      if (userClicked.has(idx) && selected) {
        display.textContent = selected.querySelector('.option-label').textContent.trim();
        display.style.color = '';
      } else if (!userClicked.has(idx)) {
        display.textContent = placeholder;
        display.style.color = '#757575';
      }
    });
    updateCartButton();
    checkUnavailableSizes();
  });

  function initPlaceholders() {
    document.querySelectorAll('variant-dropdown[data-placeholder]').forEach(function(dd) {
      const display = dd.querySelector('[data-selected-option]');
      const placeholder = dd.getAttribute('data-placeholder');
      const hasSelection = dd.querySelector('[data-product-variant].selected');
      if (!hasSelection) {
        display.textContent = placeholder;
        display.style.color = '#757575';
      }
    });
    updateCartButton();
  }

  initPlaceholders();
}

setupDropdowns();

// Clone Okendo recommendation percentage to top of reviews section
function cloneRecommendation() {
  try {
    var productType = window.ShopifyAnalytics.meta.product.type;
    if (productType && productType.toLowerCase() === 'accessories') return;
  } catch(e) {}

  const recommendModule = document.querySelector('.oke-w-recommendsModule');
  if (!recommendModule) {
    setTimeout(cloneRecommendation, 500);
    return;
  }

  if (document.querySelector('.oke-recommendation-clone')) return;

  const clone = recommendModule.cloneNode(true);
  clone.classList.add('oke-recommendation-clone');

  const summaryBlock = document.querySelector('.oke-w-reviews-summary, [data-oke-reviews-summary], .okeReviews-summary');
  if (summaryBlock) {
    summaryBlock.appendChild(clone);
  }
}

setTimeout(cloneRecommendation, 1000);
setTimeout(cloneRecommendation, 2000);

